<template>
  <div>
    <baseEdit />
  </div>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'creditAdd',
    components: {
      baseEdit,
    },
  };
</script>
